import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { InputTextModule } from 'primeng/inputtext';


const ANGULAR_MAT = [MatIconModule];
const PRIME_NG = [InputTextModule];


@Component({
  selector: 'terra-search-field',
  templateUrl: './search-field.component.html',
  styleUrls: ['./search-field.component.scss'],
  standalone: true,
  imports:[
    CommonModule,
    FormsModule,
  ...ANGULAR_MAT,
...PRIME_NG,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchFieldComponent implements OnInit {
  
  @Input() placeholder:string = '';
  @Input() filter: string; 
  @Output() filterChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() clearSearch: EventEmitter<void> = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
  }

  change(value: any) {
    this.filterChange.emit(value);
  }

  clear(searchInput: HTMLInputElement = null) {
    if (searchInput) {
      searchInput.value = null;
    }

    this.clearSearch.emit();
  }
}
